import axios from "axios";
import store from "@/store";
import router from "@/router";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000,
});

function getAccessToken() {
  // Storage is the source of truth so a stale Vuex token cannot survive logout.
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("access_token") ||
    null
  );
}

function clearAuthentication() {
  for (const key of ["token", "access_token", "user_id"]) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  // Preserve your existing Vuex UPDATE_USER mutation.
  store.commit("UPDATE_USER", null);
}

api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";
    const isLoginRequest = /(?:^|\/)auth\/login(?:\?|$)/.test(requestUrl);

    // Incorrect credentials are expected and must display on the login form.
    // Don't wipe an existing session or redirect on a failed /auth/login call.
    if (status === 401 && !isLoginRequest) {
      const hadToken = Boolean(getAccessToken());
      clearAuthentication();

      const currentPath = router.currentRoute?.value?.path;
      if (hadToken && currentPath !== "/login") {
        const redirect = router.currentRoute?.value?.fullPath || "/dashboard";
        try {
          await router.replace({ path: "/login", query: { redirect } });
        } catch (routerError) {
          if (routerError?.name !== "NavigationDuplicated") {
            console.error("Unable to redirect to login:", routerError);
          }
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
